// extracted by mini-css-extract-plugin
module.exports = {"consentContainer":"styles_consentContainer__1mv1p","consent":"styles_consent__39nB1","consentError":"styles_consentError__1ZKPj"};